import { useMemo, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import { getFacilityReservationSteps } from '../common/codeMaster'
import { useOperationLog } from '../common/operationLog'
import { OperationId } from '../common/constant/operationLog'
import { useLocation, useHistory } from 'react-router-dom'
import { reservationStatusListUrl } from '../common/constant/appUrl'
import { tabValue } from '../reservationStatusList/reservationStatusListService'

interface UrlParams {
  facilityId: string
  childId: string
  displayMode: string
}

/** 表示モード（施設予約完了画面） */
export const dispMode = {
  /** 施設予約（即時予約）*/
  insert: 'i',
  /** 施設予約変更（即時予約）*/
  update: 'u',
} as const

export const useAction = () => {
  const { addOperationLog } = useOperationLog()
  const { facilityId, childId, displayMode } = useParams<UrlParams>()

  const location = useLocation<{ lotteryAnnouncementDatetime: string }>();
  const history = useHistory();
  const announcementDatetime = location.state?.lotteryAnnouncementDatetime;
  const datetime = new Date(announcementDatetime)
  const year = datetime.getFullYear().toString()
  const month = (datetime.getMonth() + 1).toString()
  const date = datetime.getDate().toString()
  const hours = announcementDatetime.split(' ')[1].split(':')[0]
  const minutes = announcementDatetime.split(' ')[1].split(':')[1]

  // 初期表示
  useEffect(() => {
    addOperationLog({ operationId: OperationId.OP_00000001 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const steps = useMemo(getFacilityReservationSteps, [])

  const onClickShowReservationList = useCallback(() => {
    history.push(reservationStatusListUrl.url(), {
      tabValue: tabValue.lotteryReservation
    })
  }, []);

  return {
    facilityId,
    childId,
    displayMode,
    steps,
    announcementDatetime,
    year,
    month,
    date,
    hours,
    minutes,
    onClickShowReservationList
  }
}

